import {IsInt, IsOptional, IsString} from 'class-validator';

export class SaveUserPurposesDto {
  @IsInt()
  purposes!: number;

  @IsOptional()
  @IsString()
  tempRefCode?: string;
}
